<template>
    <div class="video-upload-com" :class="shapeClass_">
        <el-upload
            name="iFile"
            :action="uploadUrl"
            :headers="{ Authorization: token }"
            :file-list="mediaList"
            :limit="limit"
            list-type="picture-card"
            :before-upload="handleBeforeUpload"
            :http-request="handleRequest"
            :on-exceed="exceedTips"
            :on-remove="handleRemove"
        >
            <div slot="default">
                <i v-if="uploading" class="el-icon-loading avatar-uploader-icon" />
                <i v-if="!uploading" class="el-icon-plus avatar-uploader-icon" />
            </div>
            <div slot="file" slot-scope="{ file }">
                <div v-if="file.type === 'image'">
                    <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                    <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-preview" @click="previewImage(file)">
                            <i class="el-icon-zoom-in" />
                        </span>
                        <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                            <i class="el-icon-delete" />
                        </span>
                    </span>
                </div>

                <div v-else-if="file.type === 'video'" class="el-upload-list__itemactions" :style="{ width: width, height: height }">
                    <video :src="file.url" :style="{ width: width, height: height }" controls="controls">
                        您的浏览器不支持视频播放
                    </video>
                    <span class="item-delete" @click="handleRemove(file)">
                        <i class="el-icon-circle-close" />
                    </span>
                </div>

                <div v-else-if="file.type === 'audio'" class="el-upload-list__itemactions" :style="{ width: width, height: height }">
                    <audio :src="file.url" :style="{ width: width, height: height }" controls="controls">
                        您的浏览器不支持音频播放
                    </audio>
                    <span class="item-delete" @click="handleRemove(file)">
                        <i class="el-icon-circle-close" />
                    </span>
                </div>

                <div v-else-if="file.type === 'file'">
                    <i class="el-icon-tickets" />
                    <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-preview" @click="downloadImage(file)">
                            <i class="el-icon-zoom-in" />
                        </span>
                        <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                            <i class="el-icon-delete" />
                        </span>
                    </span>
                </div>
            </div>

            <p v-if="placeholder" slot="tip" class="el-upload__tip">{{ placeholder }}</p>
        </el-upload>
        <!-- 预览图片 -->
        <el-dialog :visible.sync="dialogVisible" :append-to-body="true" width="60%">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>

<script>
import { uploadImage, uploadQiNiu } from '@/api/upload'
import { mapGetters } from 'vuex'

export default {
    name: 'CustomUpload',
    componentName: 'CustomUpload',
    components: {},
    props: {
        value: {
            type: Array,
            default: () => []
        },
        placeholder: {
            type: String,
            default: ''
        },
        limit: {
            type: Number,
            default: 2
        },
        uploadType: {
            type: String,
            default: 'image'
        },
        isLimitM: {
            type: Boolean,
            default: false
        },
        limitM: {
            type: Number,
            default: 2
        },
        limitMin: {
            type: Number,
            default: 1
        },
        width: {
            type: String,
            default: '200px'
        },
        height: {
            type: String,
            default: '100px'
        },
        uploadAPI: {
            type: String,
            default: 'default'
        }
    },
    data() {
        return {
            uploadUrl: process.env.VUE_APP_BASE_API + '/basic/image',
            uploading: false,
            mediaList: [],
            playTime: 0,
            fileSize: 0,
            videoWidth: 0,
            videoHeight: 0,
            regImgExp: '.bmp,.gif,.jpeg,.jpg,.psd ,.pdd ,.png ,.tiff,.svg,.webp',
            regVExp: '.mov,.avi,.rmvb,.rm,.asf,.divx,.mpg,.mpeg,.mpe,.wmv,.mp4,.mkv,.vob,.3gp,.m4v,avi,.dat,.mkv,.flv,.vob',
            regAExp: '.cd,.wave,.aiff,.mpeg,.mp3,.mpeg-4,.midi,.wma,.realaudio,.vqf,.oggvorbis,.amr,.ape,.flac,.aac',
            dialogVisible: false,
            dialogImageUrl: ''
        }
    },
    computed: {
        ...mapGetters(['token']),
        shapeClass_() {
            const upload_type = this.uploadType
            return upload_type === 'video' || upload_type === 'audio' ? 'rectangle' : 'square'
        }
    },
    watch: {
        value(val) {
            this.mediaList = this.value
        }
    },
    created() {
        if (this.value) {
            this.mediaList = this.value
        }
    },
    mounted() {},
    methods: {
        exceedTips(file, fileList) {
            this.$message(`最多上传${fileList.length}个文件！`)
        },
        // 移除分享图片
        handleRemove(file, fileList) {
            console.log('file', file, fileList)
            console.log('this.value', this.value)
            console.log('this.mediaList', this.mediaList)

            const index = this.mediaList.findIndex((item) => item.id === file.id)
            if (index === -1) return
            this.mediaList.splice(index, 1)
            this.$emit('input', this.mediaList)
        },
        // 上传前回调
        handleBeforeUpload(file) {
            this.uploading = true

            let suffix_Zh = '文件'
            const suffix = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase()

            let extension = true
            switch (this.uploadType) {
                case 'image':
                    extension = this.regImgExp.indexOf(suffix) !== -1
                    suffix_Zh = '图片'
                    break
                case 'video':
                    extension = this.regVExp.indexOf(suffix) !== -1
                    suffix_Zh = '视频文件'
                    break
                case 'audio':
                    extension = this.regAExp.indexOf(suffix) !== -1
                    suffix_Zh = '音频文件'
                    break
                case 'file':
                    break
                default:
                    break
            }
            // 文件格式：拓展名
            if (!extension) {
                this.$message.error(`文件格式不正确，仅支持上传${suffix_Zh}！`)
                this.uploading = false
            }
            // 文件大小
            if (this.isLimitM) {
                const size = file.size / 1024 / 1024
                this.fileSize = size
                const isLimitMB = size < this.limitM

                // 有限制文件大小 并且文件大小大于限制大小
                if (!isLimitMB) {
                    this.$message.error(`上传文件大小不能超过${this.limitM}MB!`)
                    this.uploading = false
                }
            }
            const is_avideo = this.uploadType === 'video' || this.uploadType === 'audio'
            if (is_avideo && extension) {
                // 获取视频时长
                const videoUrl = URL.createObjectURL(file)
                const videoObj = document.createElement(this.uploadType)
                videoObj.onloadedmetadata = () => {
                    URL.revokeObjectURL(videoUrl)
                    // console.log('当前视频长度', videoObj.duration, videoObj.videoWidth, videoObj.videoHeight)
                    this.playTime = videoObj.duration // 视频时长
                    this.videoWidth = videoObj.videoWidth // 视频宽度
                    this.videoHeight = videoObj.videoHeight // 视频高度
                }
                videoObj.src = videoUrl
                videoObj.load()
            }
            // 获取文件大小
            return this.uploading
        },
        // 执行上传
        async handleRequest(res, file, fileList) {
            console.log('handleRequest----res', res)
            this.handleBeforeUpload(res.file)
            if (this.uploadAPI === 'default') {
                // 文件二进制流需要formdata
                const formdata = new FormData()
                formdata.append('iFile', res.file)
                const response = await uploadImage(formdata)
                this.handleSuccess(response)
            } else {
                const response = await uploadQiNiu()
                const { bucket, domain, host_url, token } = response.data
                const keyname =
                    bucket +
                    new Date().getTime() +
                    Math.floor(Math.random() * 100) +
                    '.' +
                    res.file.name.substring(res.file.name.lastIndexOf('.') + 1)
                const formdata = new FormData()
                formdata.append('file', res.file)
                formdata.append('token', token)
                formdata.append('key', keyname)
                const config = {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }
                this.$axios.post(host_url, formdata, config).then((qn_res) => {
                    if (qn_res.status !== 200) return
                    const extension = qn_res.data.key.substring(qn_res.data.key.lastIndexOf('.') + 1)
                    this.handleSuccess({
                        code: 200,
                        data: {
                            file_name: qn_res.data.key,
                            extension,
                            file_path: domain + '/' + qn_res.data.key
                        }
                    })
                })
            }
        },
        // 上传成功回调
        handleSuccess(res, file, fileList) {
            this.uploading = false
            if (res.code === 200) {
                const data = res.data
                const _value = this.value.filter((item) => item && item !== 'null')
                this.$emit('input', [
                    ..._value,
                    {
                        id: data.id,
                        url: data.file_path,
                        name: data.file_name,
                        type: this.uploadType,
                        extension: data.extension,
                        playTime: this.playTime,
                        size: this.fileSize,
                        width: this.videoWidth,
                        height: this.videoHeight,
                        limitMin: this.limitMin
                    }
                ])
                this.mediaList.push(fileList)
            } else {
                this.$message.error(res.message || '上传失败')
            }
        },
        // 预览
        previewImage(file) {
            this.dialogImageUrl = file.url
            this.dialogVisible = true
        },
        // 下载
        downloadImage(file) {
            window.open(file.url, '_blank')
        }
    }
}
</script>

<style rel="stylesheet/less" lang="less" scoped>
.video-upload-com {
    .video .el-upload-list {
        width: 326px;
        padding-left: 157px;
    }
    .el-upload-list__item {
        margin: 0 8px 0 0;
    }
    .el-upload-list__item-status-label {
        right: -24px;
        line-height: 0px;
        i {
            position: relative;
            top: 0px;
            left: -6px;
        }
    }
    .el-upload-list__itemactions {
        position: relative;
        .item-delete {
            position: absolute;
            top: 3px;
            right: 0px;
            cursor: pointer;
            z-index: 999999;
            font-size: 16px;
            color: #999;
        }
    }
    .el-icon-tickets {
        display: block;
        text-align: center;
        line-height: 100px;
    }
}
.square /deep/ .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 110px;
}
.square /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 100px !important;
    height: 100px !important;
    line-height: 0px !important;
}
.rectangle /deep/ .el-upload--picture-card {
    width: 200px;
    height: 100px;
    line-height: 110px;
}
.rectangle /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 200px;
    height: 100px;
    line-height: 0px !important;
}
</style>
